const warehouse = [
  {
    path: 'warehouse/receiving',
    name: 'warehouse-receiving',
    meta: {
      title: '入库管理',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/receiving.vue'], resolve)
  },
  {
    path: 'warehouse/dispatching',
    name: 'warehouse-dispatching',
    meta: {
      title: '出库管理',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/dispatching.vue'], resolve)
  },
  {
    path: 'warehouse/write-off',
    name: 'warehouse-write-off',
    meta: {
      title: '报废管理',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/write-off.vue'], resolve)
  },
  {
    path: 'warehouse/return-vendor',
    name: 'warehouse-return-vendor',
    meta: {
      title: '公司退库',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/return-vendor.vue'], resolve)
  },
  {
    path: 'warehouse/return-stock',
    name: 'warehouse-return-stock',
    meta: {
      title: '科室退库',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/return-stock.vue'], resolve)
  },
  {
    path: 'warehouse/inventory',
    name: 'warehouse-inventory',
    meta: {
      title: '盘点',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/inventory.vue'], resolve)
  },
  {
    path: 'warehouse/price-adjustment',
    name: 'warehouse-price-adjustment',
    meta: {
      title: '调价',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/price-adjustment.vue'], resolve)
  },
  {
    path: 'warehouse/traceability',
    name: 'warehouse-traceability',
    meta: {
      title: '追溯码录入',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/traceability.vue'], resolve)
  },
  {
    path: 'warehouse/doctor-used',
    name: 'warehouse-doctor-used',
    meta: {
      title: '医生用药情况',
      // requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['./views/report-list/doctor-used.vue'], resolve)
  }
]
export default warehouse
